module.exports = __webpack_public_path__ + "static/performance-af54da108b5f5f8981ca01dda380d941.png";